<template>
  <b-row>
    <b-col
      cols="12"
      md="6"
    >
      <h2>Mural</h2>
      <p>
        Fique por dentro de tudo que acontece, aqui são publicados os comunicados de seu interesse.
      </p>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-img
        class="d-none d-md-block"
        fluid
        :src="require('@/assets/images/pages/calendar-illustration.png')"
      />
    </b-col>
    <b-col
      cols="12"
      class="mt-0"
    >
      <list-mural-aviso />
    </b-col>
  </b-row>
</template>

<script>
import ListMuralAviso from './ListMuralAviso.vue'

export default {
  components: {
    ListMuralAviso,
  },
}
</script>
